export type JmapMethodCall = [string, Record<string, unknown>, string];

export type JmapRequest = {
  using: string[];
  methodCalls: JmapMethodCall[];
};

export type JmapMethodResponse = [string, Record<string, unknown>, string];

export type JmapResponse = {
  sessionState?: string;
  methodResponses: JmapMethodResponse[];
};

export type JmapSession = {
  capabilities: Record<string, unknown>;
  accounts: Record<string, { name?: string; email?: string; accountCapabilities?: Record<string, unknown> }>;
  primaryAccounts: Record<string, string>;
  username: string;
  apiUrl: string;
  state: string;
};

export type JmapMailbox = {
  id: string;
  name: string;
  role?: string | null;
  sortOrder?: number;
  totalEmails?: number;
  unreadEmails?: number;
  isSubscribed?: boolean;
};

export type JmapEmailAddress = { name?: string; email: string };

export type JmapEmail = {
  id: string;
  blobId?: string;
  threadId: string;
  mailboxIds: Record<string, boolean>;
  from?: JmapEmailAddress[] | null;
  to?: JmapEmailAddress[] | null;
  subject?: string | null;
  preview?: string | null;
  receivedAt?: string;
  sentAt?: string;
  keywords?: Record<string, boolean>;
  hasAttachment?: boolean;
  size?: number;
  messageId?: string | null;
};

export type JmapEmailBody = {
  partId?: string;
  blobId?: string;
  type?: string;
  charset?: string;
  size?: number;
  value?: string;
};

export type JmapEmailFull = JmapEmail & {
  bodyValues?: Record<string, { value?: string; isEncodingProblem?: boolean; isTruncated?: boolean }>;
  htmlBody?: JmapEmailBody[];
  textBody?: JmapEmailBody[];
  attachments?: Array<{
    blobId: string;
    type: string;
    name?: string;
    size?: number;
    cid?: string;
    disposition?: "inline" | "attachment";
  }>;
};

export type PageParams = {
  limit?: number;
  position?: number;
  filter?: Record<string, unknown>;
  sort?: Array<{ property: string; isAscending?: boolean }>;
};

export const JMAP_CORE = "urn:ietf:params:jmap:core" as const;
export const JMAP_MAIL = "urn:ietf:params:jmap:mail" as const;
export const JMAP_SUBMISSION = "urn:ietf:params:jmap:submission" as const;
export const STALWART_JMAP = "urn:stalwart:jmap" as const;

export const DEFAULT_USING = [JMAP_CORE, JMAP_MAIL, JMAP_SUBMISSION, STALWART_JMAP];
